import { render } from "./ImageDisplayDialog.vue?vue&type=template&id=1d9458d6"
import script from "./ImageDisplayDialog.vue?vue&type=script&lang=js"
export * from "./ImageDisplayDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__